import React from 'react';
import { Link } from "react-router-dom";
import { all_routes } from '../../router/all_routes';
import CollapseHeader from '../../../core/common/collapse-header';
import { checkPermission } from "../../../core/permissons/CheckPermissons";
import AddFeatures from './AddVehicle/AddFeatures';
import AddBrand from './AddVehicle/AddBrand';
import AddVehicleType from './AddVehicle/AddVehicleType';
import AddVehicleStatus from './AddVehicle/AddVehicleStatus';
import AddVehicleGearType from './AddVehicle/AddVehicleGearType';
import AddVehicleFuelType from './AddVehicle/AddVehicleFuelType';
import AddVehicleCondition from './AddVehicle/AddVehicleConditionType';
import AddVehicleClass from './AddVehicle/AddVehicleClass';
import AddVehiclePart from './AddVehicle/AddVehiclePart';

const route = all_routes;
const AddMasterData: React.FC = () => {
  const navItems1 = [
   { label: "View Dashboard", icon: "ti ti-layout-dashboard", link: route.VehicleDashboard, permission: "ADMINISTRATION_ACCESS" },
    { label: "View Vehicles", icon: "ti ti-car", link: route.VehicleView, permission: "VEHICLE_MANAGER_ACCESS" },
    { label: "Add Vehicle", icon: "ti ti-settings-cog", link: route.addvehicle, permission: "ADMINISTRATION_ACCESS" },
    { label: "Add Master Data", icon: "ti ti-car", link: route.AddMasterData, permission: "VEHICLE_MANAGER_ACCESS" },
  ];

return (
    <div className="page-wrapper">
        <div className="content">
            <div className="row">
                <div className="col-md-12">
                    {/* Page Header */}
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">Vehicle Management/Vehicles/Add Master Data</h4>
                            </div>
                            <div className="col-4 text-end">
                                <div className="head-icons">
                                    <CollapseHeader />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Page Header */}
                    {/* Settings Menu */}
                    <div className="card">
                        <div className="card-body pb-0 pt-2">
                            <ul className="nav nav-tabs nav-tabs-bottom">
                                {navItems1.map((item, index) =>
                                    item.permission && checkPermission(item.permission) ? (
                                        <li className="nav-item me-3" key={index}>
                                            <Link
                                                to={item.link}
                                                className={`nav-link px-0${index === 3 ? " active" : ""}`}
                                            >
                                                <i className={item.icon} /> {item.label}
                                            </Link>
                                        </li>
                                    ) : null
                                )}
                            </ul>
                        </div>
                    </div>
                    {/* /Settings Menu */}
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 mb-4">
                            <AddBrand />
                        </div>
                        <div className="col-xl-12 col-lg-12 mb-4">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <AddVehicleType />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <AddVehicleClass />
                                </div>
                            </div>
                              <div className="row">
                                <div className="col-md-6 mb-3">
                                    <AddVehicleStatus />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <AddVehicleGearType />
                                </div>
                            </div>

                              <div className="row">
                                <div className="col-md-6 mb-3">
                                    <AddVehicleFuelType />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <AddVehicleCondition />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <AddFeatures />
                                </div>
                                <div className="col-md-6 mb-3">
                                    < AddVehiclePart/>
                                </div>
                            </div>
                            
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>


);
};

export default AddMasterData;